"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIcon = require("@cdk-uip/react-icon");

var _Menu = require("./Menu");

var _Menu2 = _interopRequireDefault(_Menu);

var _reactPortal = require("react-portal");

var _ScrollHandler = require("./ScrollHandler");

var _ScrollHandler2 = _interopRequireDefault(_ScrollHandler);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Sub Menu. Use in conjunction with a `Menu` for adding nested sub menu.
 */


var SubMenu = function (_React$Component) {
  _inherits(SubMenu, _React$Component);

  function SubMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SubMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SubMenu.__proto__ || Object.getPrototypeOf(SubMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      openSubMenu: false,
      animateFromRight: false
    }, _this.subMenuLeft = 0, _this.subMenuTop = 0, _this.isSubMenuOpen = false, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SubMenu, [{
    key: "handleMouseEnter",
    value: function handleMouseEnter(e) {
      var _this2 = this;

      if (this.menuItem && this.subMenu && !this.isSubMenuOpen) {
        _ScrollHandler2.default.disableScroll();

        var menuItemDimension = this.menuItem.getBoundingClientRect();
        var subMenuWidth = this.subMenuDimension.width;
        var subMenuHeight = this.subMenuDimension.height;
        var viewportWidth = window.innerWidth;
        var viewportHeight = window.innerHeight;

        if (viewportWidth > menuItemDimension.right + subMenuWidth) {
          this.subMenuLeft = menuItemDimension.right;
        } else if (menuItemDimension.left - subMenuWidth > 0) {
          this.subMenuLeft = menuItemDimension.left - subMenuWidth;
          this.setState({
            animateFromRight: true
          });
        } else {
          this.subMenuLeft = viewportWidth - subMenuWidth;
        }

        this.subMenuTop = viewportHeight > menuItemDimension.top + subMenuHeight ? menuItemDimension.top : viewportHeight > subMenuHeight ? viewportHeight - subMenuHeight : 0;
        this.timer = setTimeout(function () {
          _this2.setState({
            openSubMenu: true
          });
        }, 0);
        this.isSubMenuOpen = true;
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(e) {
      this.isSubMenuOpen = false;
      clearTimeout(this.timer);

      _ScrollHandler2.default.enableScroll();

      this.setState({
        openSubMenu: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          className = _props.className,
          icon = _props.icon,
          icons = _props.icons,
          title = _props.title,
          children = _props.children,
          onSelected = _props.onSelected,
          onCancel = _props.onCancel,
          hasSubMenu = _props.hasSubMenu,
          parentindex = _props.parentindex,
          other = _objectWithoutProperties(_props, ["className", "icon", "icons", "title", "children", "onSelected", "onCancel", "hasSubMenu", "parentindex"]);

      return _react2.default.createElement("li", _extends({
        className: (0, _classnames2.default)("mdc-list-item", {
          "mdc-list-item--active-submenu": this.isSubMenuOpen
        }, className),
        role: "menuitem",
        tabIndex: "0",
        onMouseEnter: this.handleMouseEnter.bind(this),
        onMouseLeave: this.handleMouseLeave.bind(this),
        ref: function ref(menuItem) {
          _this3.menuItem = menuItem;
        }
      }, other), icon && _react2.default.createElement("span", {
        className: "mdc-menu-item-icon"
      }, icon), title, _react2.default.createElement("span", {
        className: "mdc-menu-item-trailing-icon"
      }, _react2.default.createElement(_reactIcon.Icon, null, "cascade_arrow_right")), _react2.default.createElement(_reactPortal.Portal, null, _react2.default.createElement(_Menu2.default, {
        open: this.state.openSubMenu,
        onCancel: onCancel,
        onSelected: onSelected,
        style: {
          top: this.subMenuTop,
          left: this.subMenuLeft,
          position: "fixed"
        },
        animateFromRight: this.state.animateFromRight,
        icons: icons,
        hasSubMenu: hasSubMenu,
        parentindex: parentindex,
        ref: function ref(subMenu) {
          _this3.subMenu = subMenu;
        }
      }, children)));
    }
  }, {
    key: "subMenuDimension",
    get: function get() {
      if (!this._subMenuDimension) {
        this.subMenu.menu.classList.add("mdc-menu--showTemporary");
        this._subMenuDimension = this.subMenu.menu.getBoundingClientRect();
        this.subMenu.menu.classList.remove("mdc-menu--showTemporary");
      }

      return this._subMenuDimension;
    }
  }]);

  return SubMenu;
}(_react2.default.Component);

SubMenu.propTypes = {
  /** Specifies title for sub menu item */
  title: _propTypes.string,

  /** Specifies icon for sub menu item */
  icon: _propTypes.any,

  /** Specifies that some items inside sub menu have icons, ensuring text padding is correct */
  icons: _propTypes.bool,

  /** Specifies that sub menu has nested sub menu item, ensuring padding is correct */
  hasSubMenu: _propTypes.bool
};
exports.default = SubMenu;